// src/components/Layout.js
import { SchoolFooter } from "components/SchoolFooter/schoolFooter";
import { SchoolHeader } from "components/ShoolHeader/schoolHeader";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import logoImg from 'assets/images/ssgk/ssgk-logo.png';


const  AdminLayoutComponent = ({
    navigationItems = []
  }) => {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const [showUserMenu, setShowUserMenu] = useState(false);

    const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);
    const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

    return (
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white border-b border-gray-200 fixed w-full top-0 z-50">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center">
                <button
                  onClick={toggleMobileMenu}
                  className="lg:hidden p-2 rounded-md text-gray-600 hover:bg-gray-100"
                >
                  <i className="fas fa-bars text-xl"></i>
                </button>
                <div className="flex items-center gap-2 ml-4">
                  <img
                    src={logoImg}
                    alt="Logo"
                    className="h-8 w-auto"
                  />

                </div>
              </div>




            </div>
          </div>
        </header>

        <aside
          className={`fixed left-0 top-16 h-[calc(100vh-4rem)] bg-[#0A2647] text-white transition-all duration-300 z-40
            ${sidebarCollapsed ? "w-20" : "w-64"}
            ${mobileMenuOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        >
          <div className="h-full flex flex-col">
            <div className="flex-1 overflow-y-auto py-4">
              {navigationItems.map((group, groupIndex) => (
                <div key={groupIndex} className="mb-6">
                  {!sidebarCollapsed && (
                    <div className="px-4 mb-2 text-sm font-medium text-gray-400 uppercase">
                      {group.category}
                    </div>
                  )}
                  {group.items.map((item, itemIndex) => (
                    <a
                      key={itemIndex}
                      href={item.path}
                      className={`flex items-center px-4 py-3 text-sm

                        ${sidebarCollapsed ? "justify-center" : "gap-3"}`}
                    >
                      <i className={`fas fa-${item.icon} text-xl`}></i>
                      {!sidebarCollapsed && <span>{item.label}</span>}
                    </a>
                  ))}
                </div>
              ))}
            </div>
            <div className="p-4 border-t border-[#0D2F5A]">
              <button
                onClick={toggleSidebar}
                className="w-full flex items-center justify-center gap-2 py-2 text-sm text-gray-300 hover:text-white"
              >
                <i
                  className={`fas fa-chevron-${
                    sidebarCollapsed ? "right" : "left"
                  }`}
                ></i>
                {!sidebarCollapsed && <span>Collapse</span>}
              </button>
            </div>
          </div>
        </aside>

        <main
          className={`pt-16 transition-all duration-300
            ${sidebarCollapsed ? "lg:ml-20" : "lg:ml-64"}`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    );
}
export default AdminLayoutComponent;



